import icon from 'vue-svgicon';

icon.register({
    'regular/vip-crown-queen-2': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M21.922 17.532l1.32-9.952a.75.75 0 0 0-1.078-.78l-4.281 3.259a.751.751 0 0 1-1.094-.159l-4.225-6.18a.748.748 0 0 0-1.128 0L7.211 9.9a.751.751 0 0 1-1.094.157L1.836 6.8a.75.75 0 0 0-1.078.78l1.32 9.952zM2.25 20.532h19.5" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
